const getSingleSlate = <T>(slateId: string | undefined, slates: T) => {
  if (slateId) {
    const slate = (slates as T[])?.find((data) => (data as any)?.id === slateId);
    if (slate) {
      return slate;
    }
  }

  return slates?.[0];
};

export default getSingleSlate;
